module.exports = {
    environment: 'prod',
    // environment: 'dev',
    apiport:'4100'
 }